import core from './modules/core.en';
import mm from './modules/mm.en';
import wm from './modules/wm.en';
import admin from './modules/admin.en';
import einvoicing from './modules/einvoicing.en';
import pm from './modules/pm.en';
import material from './modules/material.en';
import ab from './modules/ab.en';
import abShell from './modules/abShell.en';
import abPdf from './modules/abPdf.en';
import abMap from './modules/abMap.en';

const en = { ...core, ...mm, ...wm, ...admin, ...einvoicing, ...pm, ...material, ...ab, ...abShell, ...abPdf, ...abMap };

export default en;
